import styled from 'styled-components/macro'

export const FBPageHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 12px;
`

export const FBPageTitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  width: 100%;
`

export const FBPageTitle = styled.h1`
  font-weight: 600;
  font-size: 24px;
  line-height: 28px;
  color: #101828;
`

export const FBPageTableContainer = styled.div<{
  hide?: boolean
}>`
  display: ${(props) => (props.hide ? 'none' : 'flex')};
  flex-shrink: 1;
  width: 100%;
  flex: 1;
  min-height: 0;
`

export const FBPageInnerTabsContainer = styled.div`
  justify-content: stretch;
  align-items: flex-end;
  margin-bottom: 20px;
  gap: 100px;
`

/**
 * DS2026 page eyebrow — a small pill above the page title that identifies the
 * section of the app (e.g., "Workspace", "Targets"). Pair with an icon child
 * from `components/Layout/LeftNav/nav-icons` for visual consistency with the
 * left nav.
 */
export const FBPageEyebrow = styled.span`
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 5px;
  background: #f3f4f6;
  color: #374151;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: -0.2px;
  padding: 2px 8px;
  border-radius: 9999px;
  margin-bottom: 10px;
`
